(function ($, window) {

	let win = $(window),

		// all the sticky elements
		stickies,

		// the position at which to make all stickies stuck/unstuck
		stickyPoint,

		// admin and navbar heights
		adminbarHeight = 0,
		navbarHeight = 0,

		// store all sticky positions
		stickyOffsets = [];


	// on load lets check stickies and then set up a listener for resize
	win.on("load", () => {

		// Execute on load
		checkSticky();

		// Refresh whenever window is resized.
		win.on('resize.sticky-resize', $.debounce(150, checkSticky));

	});

	function checkSticky() {

		// get all the sticky elements and last
		stickies = $('.sidebar ul.sticky');

		// only on desktop
		if (win.outerWidth() >= 'NALU__BOOTSTRAP__BREAKPOINT__NALU') {

			let last = $('.sidebar ul.last');

			// (they both must be there for this to be useful)
			if (!stickies.length || !last.length)
				return;

			// get out if content is too short
			let contentBottom, content = $('.container.contents');

			if (content.length > 0)
				contentBottom = content.outerHeight() + content.offset().top;

			if (contentBottom < last.offset().top + win.height())
				return;

			// get the admin bar height
			let adminbar = $('#wpadminbar');
			if (adminbar.length === 1)
				adminbarHeight = adminbar.outerHeight();

			// get the admin bar height
			let navbar = $('.navbar.primary');
			if (navbar.length === 1)
				navbarHeight = navbar.outerHeight();

			// find the sticking point. If only one stick and either it's the last one or there are no other non-stickies
			if (stickies.length === 1 && (stickies.hasClass('last') || !$('.sidebar ul').not('.sticky').length))
				stickyPoint = stickies.offset().top - adminbarHeight;

			else
				stickyPoint = last.offset().top + last.outerHeight();

			// loop through store all the positions relative to sidebar up front so they position right when stuck
			stickies.each(function (i) {
				// ($(this) is each sticky element) and it's relative to the parent, the sidebar, not the page.
				stickyOffsets[i] = $(this).offset().top;
			});

			// start with unstuck on all elements
			stickies.addClass('unstuck');

			// do it initialy
			doStickiness();

			// this will fire at the very first of a scroll and then every quarter second durring that scroll
			win.on('scroll.sticky-scroll', $.throttle(100, true, doStickiness));

		}
		// make sure to turn it all off
		else {
			win.off('.sticky-scroll');
			stickies.removeAttr('style');
		}

	}

	// make it sticky or not
	function doStickiness() {

		// get the first scroll position ($(this) is window)
		let scrollPosition = $(this).scrollTop();

		// set sticky width and sticky position from top
		let stickyWidth = stickies.outerWidth();

		// store all sticky heights
		let stickyHieghts = [];

		// loop through each sticky element and stick/unstick them
		stickies.each(function (i) {

			stickyHieghts[i] = $(this).outerHeight();

			if (scrollPosition > stickyPoint && $(this).hasClass('unstuck')) {

				// make a copy of all our sticky heights to work on
				let toSum = stickyHieghts.slice();

				// only need up to our index so we can add them all (returns everything it cut but acts on the original array)
				toSum.splice(i);

				// add them all up with 20 in between and at start
				let topOffset = toSum.reduce((accumulator, currentValue) => {
					return accumulator + (parseFloat(currentValue) || 0) + 20
				}, 20);

				// allow for navbar and admin bar
				let topPosition = navbarHeight + adminbarHeight + topOffset + 'px';

				// swap calsses
				$(this).addClass('stuck').removeClass('unstuck');

				// change the inline styles
				$(this).css({
					'position': 'fixed',
					'top': $(this).offset().top - scrollPosition + 'px',
					'width': stickyWidth + "px"
				}).animate({top: topPosition}, 300);
			}

			if (scrollPosition < stickyPoint && $(this).hasClass('stuck')) {

				$(this).removeClass('stuck').addClass('unstuck');

				$(this).animate({top: stickyOffsets[i] - scrollPosition + 'px'}, 100, () => {
					$(this).removeAttr('style');
				});
			}
		});
	}
})(jQuery, window);
